import React from 'react';
import { useTheme } from './ThemeContext';
import './theme.css';

export default function ThemeToggle({ compact = false }) {
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === 'light';

  return (
    <button
      type="button"
      className="theme-toggle-btn"
      onClick={toggleTheme}
      title={isLight ? 'Switch to night mode' : 'Switch to day / light mode'}
      aria-label={isLight ? 'Switch to night mode' : 'Switch to day mode'}
    >
      <span className="theme-toggle-icon" aria-hidden>{isLight ? '🌙' : '☀️'}</span>
      {!compact && <span>{isLight ? 'Night' : 'Day'}</span>}
    </button>
  );
}
